<template>
  <span>
    <span v-if="tKey" v-html="tValue"></span>
    <span v-else v-html="cleanedValue"></span>
  </span>
</template>

<script>
export default {
  name: "LocalizeWord",
  props: ["value"],
  computed: {
    tKey() {
      if (
        this.cleanedValue &&
        this.cleanedValue.length > 2 &&
        this.cleanedValue.startsWith("{") &&
        this.cleanedValue.endsWith("}")
      ) {
        return this.cleanedValue.substring(1, this.cleanedValue.length - 1);
      } else {
        return null;
      }
    },

    tValue() {
      return this.$t(this.tKey).replace(/<(?!wbr\s*\/?)[^>]+>/gm, ""); //https://regex101.com/r/sROTjR/1  Remove all tags except word-break
    },

    cleanedValue() {
      if (this.value) {
        return this.value.replace(/<(?!wbr\s*\/?)[^>]+>/gm, ""); //https://regex101.com/r/sROTjR/1  Remove all tags except word-break
      }
      return null;
    }
  }
};
</script>
